// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"96fad69754700106","5763":"d5041f605c104a84","6893":"fd2ecb7f91419115","6974":"6fed18d8e5e01951","7222":"acb9182e6a2cdeb5","7937":"8a15c40d0c8f113c"}[chunkId] + ".js";
};